import DateUtils from '../../utils/date';
import { getFormatByViews } from '../helpers';
export function useOptions(props) {
  var utils = new DateUtils();
  return {
    getDefaultFormat: function getDefaultFormat() {
      return getFormatByViews(props.views, utils);
    }
  };
}